"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClipPath = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeSvg = require("react-native-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClipPath = function (props) {
  var children = props.children,
      clipId = props.clipId; // Wrap in G not to cause exceptions in old react-native-svg
  // https://github.com/FormidableLabs/victory-native/issues/432#issuecomment-475927581

  return /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null, /*#__PURE__*/_react.default.createElement(_reactNativeSvg.Defs, null, /*#__PURE__*/_react.default.createElement(_reactNativeSvg.ClipPath, {
    id: clipId
  }, children)));
};

exports.ClipPath = ClipPath;